import React from 'react';
import { Translation } from 'react-i18next';
import { withRouter } from 'react-router';
import QueryString from '../../../../../lib/QueryString';
import CognitoFormForm from '../containers/CognitoFormFormContainer';
import Logger from '../../../../../lib/Logger';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import { Col, Row } from 'antd';
import DocumentHead from '../../../elements/components/DocumentHead';

const CognitoFormScreen = ({ history, destroySession, ...props }) => {
  const params = QueryString.parse(props.location.search);
  const cognitoId = 'cti' in params ? params.cti : null;
  const cognitoKey = 'ctk' in params ? params.ctk : null;
  const newUserRequirement = 'nwur' in params ? params.nwur : null;
  const careGuideId = 'cid' in params ? params.cid : null;
  const cognitoFormId = 'cfi' in params ? params.cfi : null;
  const oldUserRequirement = 'our' in params ? params.our : null;
  const isOldUser = 'iou' in params ? params.iou : 'false';

  const logout = () => {
    Logger.log('debug', `DrawerMenu.logout()`);
    destroySession(() =>
      history.push(pathTo(Config.get('DEFAULT_LOGIN_SCREEN')))
    );
  };

  if (!cognitoId || !cognitoKey || !newUserRequirement) {
    logout();
  }

  return (
    <Translation>
      {(t) => (
        <div
          className='screen screen-public screen-register'
          style={{ marginTop: '40px' }}
        >
          <DocumentHead title={t('cognito_forms_admin_route_list')} />

          <div className='container-form-register'>
            <Row type='flex' justify='space-around' align='middle'>
              <Col xs={22} sm={18} md={16} lg={14} xl={8}>
                <div class='outer-container'>
                  <div class='inner-container'>
                    <h1 style={{ fontWeight: 'bold' }}>
                      {t('cognito_forms_screen_title')}
                    </h1>
                    <h2>{t('cognito_forms_screen_subtitle')}</h2>
                    <CognitoFormForm
                      cognitoId={cognitoId}
                      cognitoKey={cognitoKey}
                      newUserRequirement={parseInt(newUserRequirement)}
                      careGuideId={careGuideId}
                      history={history}
                      cognitoFormId={cognitoFormId}
                      oldUserRequirement={parseInt(oldUserRequirement)}
                      isOldUser={JSON.parse(isOldUser.toLowerCase())}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </Translation>
  );
};

export default withRouter(CognitoFormScreen);
